import { user } from "@/services/user";
import { useQuery } from "react-query";
import { NewGenericAccount } from "@/types/user.types";
import { DEBUGGER } from "@/helper/helper";

const useAccountNewShow = (withQrPermissions = false) => {
  const {
    data: accountNewData,
    isLoading: isLoadingNewAccount,
    isSuccess: isAccountSuccess,
    refetch,
  } = useQuery<NewGenericAccount>(
    ["ACCOUNT_NEW_SHOW", withQrPermissions],
    () => user.accountNewShow(withQrPermissions),
    {
      onError: (error: unknown) => {
        DEBUGGER("Error fetching account new show => ", error);
      },
    },
  );

  return {
    refetch,
    accountNewData,
    isLoadingNewAccount,
    isAccountSuccess,
  };
};

export default useAccountNewShow;
